<template>
  <c-widget-control-bar>
    <v-form-group :label="$t('white-label.widgets.marketDepthL2.view.label')" label-cols="auto">
      <v-form-select
        :value="view"
        :options="[
          { value: 'by-price', text: this.$t('white-label.widgets.marketDepthL2.view.options.byPrice') },
          { value: 'by-order', text: this.$t('white-label.widgets.marketDepthL2.view.options.byOrder') }
        ]"
        @input="$emit('update-view', $event)"
        :aria-label="$t('white-label.widgets.marketDepthL2.view.label')"
      />
    </v-form-group>
  </c-widget-control-bar>
</template>

<script>
import CWidgetControlBar from '@custom/widgetContainer/CWidgetControlBar';

export default {
  name: 'w-control-bar',
  components: {
    CWidgetControlBar
  },
  props: {
    view: {
      type: String,
      required: true
    }
  }
};
</script>
